<template>
  <div class="col-xs-10 col-sm-10 grid_div" id="grid_right_div">
    <!--<div id="flushBtn"></div>-->
    <div id="contentDiv">
      <div class="head_title">
        <div class="head_title_font">信息管理&gt;编辑信息</div>
      </div>
      <div class="body_content">
        <!-- 模态框（Modal） -->
        <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
          <div class="modal-dialog time_dialog">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                <h4 class="modal-title" id="myModalLabel">定时发送</h4>
              </div>
              <div class="modal-body">
                <input class="form-control" size="16" type="text" name="createTime" id="createTime" v-model="messageInfo.createTime" readonly/>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn" @click="writeMessage('publishTime')">确定</button>
                <button type="button" class="btn" data-dismiss="modal">取消</button>
              </div>
            </div>
          </div>
        </div>

        <div class="msg_div">
          <div class="btns_div">

            <div class="msgBtn"> <input type="checkbox" id="shotmsgnotice" v-model:checked="shotmsgFlag"/> <label for="shotmsgnotice">短信通知</label></div>
            <div class="msgBtn" @click="writeMessage('publish')">发布</div>
            <div class="msgBtn" data-toggle="modal" data-target="#myModal"  v-if="!shotmsgFlag">定时发布</div>
            <div class="msgBtn" @click="writeMessage('save')" v-if="!shotmsgFlag">保存不发布</div>
            <div class="msgBtn" @click="reBackMsgList()">返回</div>
            <div class="msgBtn_" v-if="!shotmsgFlag">
              <input type="checkbox" id="tracking_label" @click="messageInfo.iftrace == 1?messageInfo.iftrace=0:messageInfo.iftrace=1"
                     :checked="messageInfo.iftrace == 1"/>
              <label for="tracking_label">定时追踪</label>
              <select class="form-control" v-model="messageInfo.traceRate">
                <option value="">请选择追踪频率</option>
                <option v-for="(val, key, index) in traceRate_arr" :key="index" :value="key">{{val}}</option>
              </select>
            </div>
          </div>
          <div class="msg_content_div">
            <div class="inputDiv">
              <label class="labelClass">收件人</label>
              <!--<input type="text" class="form-control inputClass" v-model="messageInfo.recName"/>-->
              <div class="form-control res_div">
                <span v-for="(rec, index) in messageInfo.receivers" style="margin: 2px 5px;">
                  {{rec.recName}}<!--<span title="删除" class="glyphicon glyphicon-remove" @click=""></span>-->;
                </span>
              </div>
              <span class="spanRed receiver">*</span>
            </div>
            <div class="inputDiv" v-if="shotmsgFlag">
              <label class="labelClass">短信模板</label>
              <select class="form-control" v-model="templateId">
                <option value="">请选择短信模板</option>
                <option v-for="(item, index) in templateList" :key="index" :value="item.id">{{item.title}}</option>
              </select>
            </div>
            <div class="inputDiv" v-if="shotmsgFlag">
              <div  style="width: 55%; margin: 20px 0 0 10%;display: inline-block">
              <div class="form-control sms_div" style="width: 100%" v-html="shotMsgForInput">
              </div>
              </div>
              <div  style="width: 30%;margin: 20px 0 0 2%;display: inline-block" v-if="shotMsgForShow">
                <div class="form-control sms_div">
                  【鄂尔多斯智慧党校】{{shotMsgForShow}}
                </div>
                <div>共{{shotMsgForShow.length + 10}}字，{{Math.ceil((shotMsgForShow.length + 10)/70)}}条短信</div>
              </div>
            </div>

            <div class="inputDiv" v-if="!shotmsgFlag">
              <label class="labelClass">主题</label>
              <input type="text" v-validate="'required|maxL:50'" data-vv-scope="message" data-vv-as="主题" name="title" class="form-control inputClass" v-model="messageInfo.title"/>
              <span class="spanRed title">*</span>
              <span class="validateTip">{{ errors.first('message.title') }}</span>
            </div>

            <div class="inputDiv" v-if="!shotmsgFlag">
              <label class="labelClass">正文</label>
              <textarea v-validate="'required|maxL:300'" data-vv-scope="message" data-vv-as="正文" name="content"  class="form-control inputClass textAreaClass" v-model="messageInfo.content"></textarea>
              <span class="spanRed content">*</span>
              <span class="validateTip">{{ errors.first('message.content') }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="address_list_div">
        <ul id="myTab" class="nav nav-tabs">
          <li class="active">
            <a href="#numberBook" data-toggle="tab">通讯录</a>
          </li>
          <li>
            <a href="#classBook" data-toggle="tab">班级</a>
          </li>
        </ul>

        <div id="myTabContent" class="tab-content">
          <div style="margin-left: 40px;">
          <input type="text" class="form-control" style="display: inline-block;width: 120px" placeholder="姓名或班级" v-model="searchName">
          <button type="button" class="btn btn-default btn_option" @click="filterName">查询</button>
          <button type="button" class="btn btn-default" @click="resetFilter()">重置</button>
          </div>
          <div class="tab-pane fade in active" id="numberBook">
            <div class="bookUl">
              <ul>
                <li v-if="!shotmsgFlag">
                  <input type="checkbox" id="check_1" @click="addReceivers('111', '全体人员', '1')"
                         v-bind:checked="haveReceiversId.indexOf('111')!=-1"/>
                  <label for="check_1">全体人员</label>
                </li>
                <li>
                  <input type="checkbox" id="check_2" @click="addReceivers('222', '全体教职人员', '2')"
                         v-bind:checked="haveReceiversId.indexOf('222')!=-1"/>
                  <label for="check_2">全体教职人员</label>
                </li>
                <li v-if="!shotmsgFlag">
                  <input type="checkbox" id="check_3" @click="addReceivers('333', '全体学员', '3')"
                         v-bind:checked="haveReceiversId.indexOf('333')!=-1"/>
                  <label for="check_3">全体学员</label>
                </li>
                <li v-for="(addressOne, index) in addressBookList" :key="index">
                  <input type="checkbox" :id="gernerateCheckId(addressOne.id)" @click="addReceivers(addressOne.id, addressOne.userName, '9')"
                         v-bind:checked="haveReceiversId.indexOf(addressOne.id)!=-1"/>
                  <label :for="gernerateCheckId(addressOne.id)">{{addressOne.userName}}</label>
                </li>
              </ul>
            </div>
          </div>
          <div class="tab-pane fade" id="classBook">
            <div class="bookUl">
              <ul>
                <li v-for="(clazzOne, index) in clazzList" :key="index">
                  <input type="checkbox" :id="gernerateCheckId(clazzOne.id)" @click="addReceivers(clazzOne.id, clazzOne.name, '4')"
                         v-bind:checked="haveReceiversId.indexOf(clazzOne.id)!=-1"/>
                  <label :for="gernerateCheckId(clazzOne.id)">{{clazzOne.name}}</label>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {getContentSize} from './mainView';
  import {schoolAxios} from "../main";
  import dictionaryData from '../json/dictionary';

  export default {
    name: "writeMsg",
    data() {
      return {
        msgId: this.$store.state.msgDetailsId,

        traceRate_arr: dictionaryData.trace_rate,

        shotmsgFlag: false,

        messageList: [],

        haveReceiversId: [],

        //通知对象
        messageInfo: {
          clazzId:'',
          content:'',
          createTime:'',
          deviceToken:'',
          fixed:'',
          id:'',
          iftrace:'',
          recName:'',
          recType:'',
          receivers:[],
          status:'',
          title:'',
          traceRate:'',
          template: ''
        },
        current_index: 0,

        clazzList: [],
        clazzListTemp: [],

        templateList: [],

        template: {},
        templateId: '',
        shotMsgForShow:"",
        shotMsgForInput:"",
        shotMsgData:{},

        addressBookList: [],
        addressBookListTemp: [],

        timeDate: '',

        searchName:""
      }
    },
    filters: {

    },
    created: function () {
      window.toTemplate = this.toTemplate;
    },
    mounted: function () {
      let this_ = this;
      this.$nextTick(function () {
        getContentSize();

        this_.initWriteMsgData();

        this_.loadAddressBookAndClass();

        this_.dateDefault();

        this_.closeModal();

        this_.initTemplateList();
      })
    },
    watch:{
      "templateId": function (id){
        this.templateSelect(id);
      },
      "shotmsgFlag":function (val){
        if(val === true){
          this.messageInfo.receivers = this.messageInfo.receivers.filter(r => r.recType!=1 && r.recType!=3)
          this.haveReceiversId = this.haveReceiversId.filter(r => r!='111' && r!='333');
        }
      }
    },
    methods: {
      initWriteMsgData(){
        let this_=this;
        if(this_.msgId) {
          schoolAxios({
            method: 'get',
            url: 'notice/loadDetails/' + this_.msgId,
            params: {}
          }).then(function (response) {
            let data = response.data;
            if (data.success) {
              if (data.data) {
                this_.messageInfo = data.data;
                let receiversList = data.data.receivers;
                if (receiversList && receiversList.length > 0) {
                  for (let i = 0; i < receiversList.length; i++) {
                    this_.haveReceiversId.push(receiversList[i].recId);
                  }
                } else {
                  this_.messageInfo.receivers = [];
                  this_.haveReceiversId = [];
                }
              }
            }
          })
        }
      },


      /**
       * 添加发送人列表
       */
      addReceivers(id, name, type){
        let this_ = this;
        if(this_.haveReceiversId.indexOf(id) == -1){
          this_.haveReceiversId.push(id);
          let my_data = {
            recId: id,
            recName: name,
            recType: type,
          };
          let index = this_.messageInfo.receivers.length;
          this_.messageInfo.receivers.splice(index, 0, my_data);
        }else{
          let index = this_.haveReceiversId.indexOf(id);
          this_.messageInfo.receivers.splice(index, 1);
          this_.haveReceiversId.splice(index, 1);
        }
      },

      /**
       * 写信息，未完
       */
      writeMessage(flag){
        let this_=this;
        let tip = "";
        let status = 0;
        let fixed = 0;
        this_.$validator.validateAll('message').then(result => {
          if (result) {
            if (flag == 'publish') {//发布
              if(this_.messageInfo.receivers.length==0){
                "请选择收件人".showMessage();
                return false;
              }
              tip = "确定发布信息？";
              status = 1;
              fixed = 0;
            } else if (flag == 'publishTime') {//定时发布
              if(this_.messageInfo.receivers.length==0){
                "请选择收件人".showMessage();
                return false;
              }
              tip = "确定定时发布？";
              status = 0;
              fixed = 1;
            } else {//保存不发布
              tip = "确定保存不发布？";
              status = 0;
              fixed = 0;
            }
            if(this_.shotmsgFlag){
              if(!this_.templateId){
                "请选择短信模板，编辑短信".showMessage();
                return false;
              }
              if(!this_.shotMsgForShow){
                "请编辑短信内容".showMessage();
                return false;
              }
              tip = "确定发送短信？"
              status = 1;
              fixed = 0;
            }
            (tip).showConfirm(function () {
              schoolAxios({
                method: 'post',
                url: 'notice/add',
                data: {
                  id: this_.messageInfo.id,
                  title: this_.shotmsgFlag?"发送短信-" + this_.template.title:this_.messageInfo.title,
                  content: this_.shotmsgFlag?this_.shotMsgForShow:this_.messageInfo.content,
                  status: status,
                  iftrace: this_.messageInfo.iftrace,
                  traceRate: this_.messageInfo.traceRate,
                  fixed: fixed,
                  createTime: this_.messageInfo.createTime,
                  receiversJson: JSON.stringify(this_.messageInfo.receivers),
                  templateId: this_.shotmsgFlag?this_.templateId:"",
                  msgData: this_.shotmsgFlag?JSON.stringify(this_.shotMsgData):"",
                }
              }).then(function (response) {
                let data = response.data;
                if (data.success) {
                  $("#myModal").modal("hide");
                  // "发布成功".showMessage();
                  this_.reBackMsgList();
                } else {
                  "发布失败".showMessage();
                }
              });
            })
          }
        });
      },

      /**
       * 加载通讯录列表和班级列表
       */
      loadAddressBookAndClass(){
        let this_=this;
        schoolAxios({
          method: 'get',
          url: 'user/findListByRoleCodes',
          params:{}
        }).then(function (response) {
          let data = response.data;
          if(data.success){
            this_.addressBookList=data.list;
          }
        });
        schoolAxios({
          method: 'get',
          url: 'clazz/findOpenOrUnOpenClassList',
          params:{}
        }).then(function (response) {
          let data = response.data;
          if(data.success){
            this_.clazzList = data.list;
          }
        });
      },

      /**
       * 返回信息列表
       */
      reBackMsgList(){
        let this_ = this;
        //路由跳转
        this_.$router.push({
          name: 'Message',
        });
      },

      gernerateCheckId(id){
        return "check_"+id;
      },

      filterName(){
        if(this.searchName){
          if(!this.addressBookListTemp || this.addressBookListTemp.length==0)
            this.addressBookListTemp = this.addressBookList;
          if(!this.clazzListTemp || this.clazzListTemp.length==0)
            this.clazzListTemp = this.clazzList;

          this.addressBookList = this.addressBookListTemp.filter(item => {
            if( ! item.userName) return false;
            return item.userName.indexOf(this.searchName)>=0
          })
          this.clazzList = this.clazzListTemp.filter(item => {
            if( ! item.name) return false;
            return item.name.indexOf(this.searchName)>=0
          })
        }else{
          this.resetFilter();
        }
      },
      resetFilter(){
        this.searchName = "";
        if(this.addressBookListTemp && this.addressBookListTemp.length>0)
          this.addressBookList = this.addressBookListTemp;
        if(this.clazzListTemp && this.clazzListTemp.length>0)
          this.clazzList = this.clazzListTemp;
      },

      /**
       * 关闭模态框监听
       */
      closeModal() {
        let this_ = this;
        $("#myModal").on('hide.bs.modal', function () {
          //this_.messageInfo.createTime = "";
        });
      },

      dateDefault(){
        let this_ = this;
        let date, nowDate;
        date = new Date();
        nowDate = date.getFullYear() + "-";//取年份
        nowDate += (date.getMonth() + 1) + "-";//取月份,date生成的月份为0-11
        nowDate += date.getDate() + " ";//取日期
        nowDate += date.getHours() + ":";//取小时
        nowDate += date.getMinutes() + ":";//取分
        nowDate += date.getSeconds();//取秒
        this_.timeDate = nowDate;
        $('#createTime').datetimepicker({
          //minView: "month",
          language: 'zh-CN',
          format: 'yyyy-mm-dd hh:ii',
          startDate: this_.timeDate,
          weekStart: 0,
          todayBtn: true,
          clearBtn: true,
          autoclose: true,
          todayHighlight: true,
          startView: 2,
          forceParse: 0,
          showMeridian: 1
        }).on('hide', function (ev) {
          let value = $("#createTime").val();
          this_.messageInfo.createTime = value;
        });
      },

      /**
       * 初始化短信模板
       */
      initTemplateList(){
        let this_ = this;
        schoolAxios({
          method: 'get',
          url: 'notice/getTemplateList',
          params: {}
        }).then(function (response) {
          let data = response.data;
          if (data.success) {
            this_.templateList = data.list;
          }
        })
      },
      templateSelect(id){
        this.template = this.templateList.filter(t => t.id == id)[0];

        let tp = this.template.template
        let array = tp.match(/{(.*?)}/g)
        if (array && array.length) {
          array.forEach(val => {
            let val1 = val.substring(1, val.length - 1)
            let input_str = "<input type=text dataname=" + val1 + " class=msg_input onkeyup='toTemplate()' onpaste='toTemplate()'/>"
            tp = tp.replace(val, input_str)
          })
          this.shotMsgForInput = tp;
        }
        this.shotMsgForShow = "";
      },
      toTemplate(){
        //获取值
        let elements = document.getElementsByClassName("msg_input");
        for (let i = 0; i < elements.length; i++) {
          const item = elements[i]
          this.shotMsgData[item.attributes.dataname.value] = item.value
        }

        //生成短信内容
        let template  = this.template.template;
        for(let key in this.shotMsgData){
          template = template.replace("{" + key + "}", this.shotMsgData[key]);
        }
        this.shotMsgForShow = template;
      },
    }
  }
</script>

<style scoped>
  @import '../assets/css/plugins.css';
  @import "../assets/css/publicStyle.css";
  @import "../assets/css/writeMsg.css";

  ul.b {list-style-type:square;}
</style>
<style>
.inputDiv .msg_input{
  width: 200px;
  margin: 0 5px 0 5px;
  border-width: 0 0 1px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/writeMsg.vue